// Shared Asian country + region data for supplier onboarding and buyer filtering.

export const REGIONS = {
  "Southeast Asia": [
    "Vietnam", "Thailand", "Indonesia", "Philippines", "Malaysia",
    "Singapore", "Cambodia", "Laos", "Myanmar", "Brunei", "Timor-Leste",
  ],
  "East Asia": ["China", "Japan", "South Korea", "Taiwan", "Hong Kong", "Mongolia"],
  "South Asia": [
    "India", "Bangladesh", "Sri Lanka", "Nepal", "Pakistan", "Bhutan", "Maldives",
  ],
  "Central Asia": ["Kazakhstan", "Uzbekistan", "Kyrgyzstan", "Tajikistan", "Turkmenistan"],
  "West Asia": ["Turkey", "United Arab Emirates", "Saudi Arabia", "Qatar", "Israel", "Jordan"],
};

export const ASIAN_COUNTRIES = Object.values(REGIONS).flat();

export const REGION_LIST = Object.keys(REGIONS);
